import { render, staticRenderFns } from "./KpisProperties.vue?vue&type=template&id=7637c614&scoped=true"
import script from "./KpisProperties.vue?vue&type=script&lang=js"
export * from "./KpisProperties.vue?vue&type=script&lang=js"
import style0 from "./KpisProperties.vue?vue&type=style&index=0&id=7637c614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7637c614",
  null
  
)

export default component.exports